import { createRef, CSSProperties, ReactNode, useContext, useMemo } from 'react'
import useStyles from './styles'
import { MultiPaneLayoutContext } from '../multipPaneLayout.context'
import PaneDivider from '../paneDivider'
import HorizontalSplitSharpIcon from '@mui/icons-material/HorizontalSplitSharp'
import VerticalSplitSharpIcon from '@mui/icons-material/VerticalSplitSharp'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import { IconButton } from '@mui/material'

export type PaneContainerProps = {
    paneId: number,
    parentPaneId?: number,
    hidePaneActionButtons?: boolean
}

const PaneContainer: React.FC<PaneContainerProps> = ({ paneId, parentPaneId, hidePaneActionButtons }) => {
    const layoutContext = useContext(MultiPaneLayoutContext)
    const pane = layoutContext.panesConfig[paneId]
    const parentPane = parentPaneId ? layoutContext.panesConfig[parentPaneId] : null
    const { id, horizontal, panes } = pane
    const containerRef = createRef<HTMLDivElement>()
    const style: CSSProperties = {
        width: `${layoutContext.paneStyles[id]?.width || 0}px`,
        height: `${layoutContext.paneStyles[id]?.height || 0}px`,
        flexDirection: horizontal ? 'row' : 'column'
    }
    const { classes } = useStyles()

    const children = useMemo(() => {
        const childNodes: ReactNode[] = []
        if (panes.length) {
            panes.map((v, i) => {
                childNodes.push(<PaneContainer paneId={v.id} parentPaneId={pane.id} key={v.id}
                                               hidePaneActionButtons={hidePaneActionButtons} />)

                if (i !== panes.length - 1) {
                    childNodes.push(<PaneDivider vertical={horizontal} thickness={1} paneId={pane.id} index={i}
                                                 key={`pane-${v.id}-divider`} />)
                }
            })
        }
        return childNodes
    }, [id, panes.map(v => v.id).join(',')])

    return <div className={classes.container} key={id} style={style} ref={containerRef} id={`pane-${id}`}>
        {!panes.length && !hidePaneActionButtons && <div className={classes.actionsContainer}>
            <IconButton onClick={() => layoutContext.splitPane(id, 2, true, parentPane?.id)}><VerticalSplitSharpIcon
                fontSize="small" /></IconButton>
            <IconButton onClick={() => layoutContext.splitPane(id, 2, false, parentPane?.id)}><HorizontalSplitSharpIcon
                fontSize="small" /></IconButton>
            {parentPaneId &&
                <IconButton onClick={() => layoutContext.deletePane(id, parentPaneId)}><DeleteOutlineOutlinedIcon
                    fontSize="small" /></IconButton>}
        </div>}
        {children}
    </div>
}

export default PaneContainer